/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { PlanResponse } from './planResponse';
import type { SubscriptionAddonRef } from './subscriptionAddonRef';

export interface SubscriptionResponse {
  id: string;
  plan: PlanResponse;
  status: string;
  billing_cadence: string;
  seat_count: number;
  current_period_start: string | null;
  current_period_end: string | null;
  cancel_at: string | null;
  resume_at?: string | null;
  managed_externally: boolean;
  addons?: SubscriptionAddonRef[];
  pending_downgrade_plan?: PlanResponse | null;
  pending_downgrade_cadence?: string | null;
  pending_downgrade_seat_count?: number | null;
  pending_downgrade_at?: string | null;
  discount_percent?: number | null;
  discount_period_end?: string | null;
}
